import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

const currentMain = () => [...document.scripts].map((s) => s.src).find((s) => /\/static\/js\/main\./.test(s)) || "";

export const VersionBanner = () => {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    const mine = currentMain();
    if (!mine) return;
    const check = () => fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: "no-store" }).then((r) => r.json())
      .then((m) => { const latest = m?.files?.["main.js"]; if (latest && !mine.endsWith(latest)) setStale(true); }).catch(() => {});
    const t = setInterval(check, 120_000);
    const onFocus = () => check();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, []);
  if (!stale) return null;
  return (
    <div className="flex items-center justify-between gap-3 bg-amber-100 px-4 py-2 text-sm text-amber-900 print:hidden" data-testid="version-banner">
      <span>Une nouvelle version de l'application est disponible. Terminez votre opération en cours puis rechargez.</span>
      <button type="button" onClick={() => window.location.reload()} className="inline-flex items-center gap-1 rounded-md bg-amber-600 px-3 py-1 text-xs font-semibold text-white hover:bg-amber-700" data-testid="version-reload-btn"><RefreshCw size={12} /> Recharger</button>
    </div>
  );
};
